import { Note } from './note';
import { EnrichmentPage } from './enrichmentPage';
import { EnrichmentDescription } from './enrichmentDescription';
export class Page {
    public annotations: Number = 0;
    public bookmarks: Number = 0;
    public drawingArr: Array<any> = new Array<any>();
    public drawing:  Number = 0;
    public contentDocId: String = "";
    public isPage: boolean = true;
    public isCustomBg:boolean = false;
    public pageNumber: Number = 1;
    public title: String = "";
    public notes: Array<Note> = new Array<Note>();
    public enrichment_page: Array<EnrichmentPage> = new Array<EnrichmentPage>();
    public id: String = "";
    public type: String = 'blankPage';
    public children: Array<Page> = new Array<Page>();
    public description: EnrichmentDescription = new EnrichmentDescription();
}



// WEBPACK FOOTER //
// ./src/app/shared/models/page.ts